import * as Sentry from '@sentry/browser';
import ConfirmTable from 'components/ConfirmTable';
import SelectTable from 'components/SelectTable';
import { eventNames } from 'configuration/eventNames';
import ReviewOrder from 'containers/ReviewOrder';
import SafariAddressBarDetector from 'detect-ios-address-bar';
import {
  engineAddHalfHalfToOrder,
  engineAddHalfItemsToOrder,
  engineAddItemsToOrder,
  engineAddTableToOrder,
  engineAddToHalfHalf,
  engineAddToOrder,
  engineAddToSpecial,
  engineClearOrChangeSize,
  engineDecrementExtraQuantity,
  engineDecrementItemQuantity,
  engineDoASelfMerge,
  engineGetOrderCalculations,
  engineIncrementExtraQuantity,
  engineIncrementItemQuantity,
  engineRemoveOutOfScheduleItems,
  engineRemoveSoldOutItems,
  engineShowHalfItem,
  engineShowMenuItemHandler,
  engineShowSpecialItem,
  engineUpdateDeliveryPickupTime,
  engineUpdateOrderDeliveryAddress,
  engineUpdatePaymentTypeForNewCard,
  engineUpdatePaymenyType,
} from 'helpers/order-engine';
import localStorage from 'local-storage';
import moment from 'moment-timezone';
import {
  getVoucherDiscountedAmount,
  getItemsInCart,
} from '@next-order/next-order-engine';
import queryString from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MenuItems from '../../components/MenuItems';
import Layout from '../../containers/Layout';
import Order from '../../containers/Order';
import { firebaseAnalyticsNO, _auth } from '../../firebase';
import { getDineInObjects } from '../../helpers/getDineInObjects';
import getFormattedMobileNumber from '../../helpers/getFormattedMobileNumber';
import { getCurrentTimestamp } from '../../helpers/timeHelper';
import {
  addReservation,
  filterView,
  getCurrentUseDetails,
  init,
  setLayoutFlow,
  setState,
  takeSignOutAction,
  toggleMobileCart,
  updateCurrentOrderObj,
} from './actions';
import { loadCurrentOrderMethod } from './methods';
import { getMenuItemForInstore } from 'helpers/getMenuItemForInstore';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowItems: [],
      selectedHalfItems: [],
      toggleAnimation: false,
      toggleSpecials: false,
      toggleSpeacialItem: false,
      halfItem: {},
      specialItem: {},
      arrKey: '',
      halfAnimation: false,
      rightSideViewVisibilityIndex: 0,
      itemVariants: [],
      whichHalf: 0,
      itemExist: -1,
      inLayoutFlow: false,
      loyalty: false,
      dineInObjects: [],
      floors: {},
      showSelectTable: false,
      showConfirmTable: true,
    };
    this.specialItemsObj = [];
    this.query = new URLSearchParams(window.location.search);
    this.qrRedirect = this.query.get('qrRedirect');
    this.qrTracking = this.query.get('qrTracking');
  }

  componentWillMount() {
    const {
      currentOrder,
      storeConfig,
      initAction,
      getCurrentUseDetailsHandler,
    } = this.props;

    initAction(storeConfig.storeId, storeConfig.restaurantId);

    _auth.onAuthStateChanged((user) => {
      if (user) {
        getCurrentUseDetailsHandler(
          user,
          null,
          storeConfig.storeId,
          storeConfig.restaurantId
        );
      }
    });
    const loadedOrder = loadCurrentOrderMethod(storeConfig, currentOrder);
    if (loadedOrder.type === '1') {
      loadedOrder.address = '';
      loadedOrder.addressLocation = '';
      loadedOrder.placeId = '';
      loadedOrder.suburbId = '';
      loadedOrder.minOrderValue = '';
      loadedOrder.areaCode = '';
      loadedOrder.area = '';
      loadedOrder.deliveryCost = 0;
      loadedOrder.deliveryDate = undefined;
      loadedOrder.deliveryData = {};
    } else {
      loadedOrder.deliveryDate = undefined;
    }
    let { currentOd, rowItems } = engineGetOrderCalculations(
      loadedOrder,
      this.props
    );
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });

    if (this.qrRedirect === 'true' || this.qrTracking === 'close') {
      this.goHome();
    }
  }

  componentDidMount() {
    firebaseAnalyticsNO.logEvent(eventNames.HOME_PAGE_VISITED);
    this.handleRedirectionFromMultistore();

    // Initialize instance
    const safariAddressBar = new SafariAddressBarDetector();
    if (safariAddressBar) {
      if (safariAddressBar.isTargetDevice) {
        document.body.style.marginBottom = `40px`;
      }
    }
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });
  }

  confirmTable = (number) => {
    const selectedTables = this.state?.dineInObjects?.filter(
      (item) => item.name === number || item.number === number
    );

    if (selectedTables.length !== 1) {
      this.setState({ showSelectTable: true });
    } else {
      this.addTableToOrder(selectedTables[0]);
    }
  };

  checkForDineIn = async () => {
    const { home, currentOrder, storeConfig, history } = this.props;
    const { storeId } = storeConfig;
    const pathname = window.location.pathname;
    const isDineIn = pathname.includes('dine-in');
    const type = 'dine-in';
    let dineInObject = null;

    if ((isDineIn || currentOrder?.orderType === '3') && home.orderSetup) {
      const isDineInDisabled = !home.orderSetup.isDineInOn;

      if (isDineInDisabled) {
        history.push('/');
        return;
      }
      const { tables: dineInObjects, floors } = await getDineInObjects(storeId);
      this.setState({ type, dineInObjects, floors });

      // pre-select the table if it's in the url
      const urlPaths = pathname.split('/').filter(Boolean);
      const isTableNumber = isDineIn && urlPaths.length === 3;
      const floorLayoutId = isTableNumber
        ? urlPaths[urlPaths.length - 2]
        : false;
      const number = isTableNumber
        ? urlPaths[urlPaths.length - 1]?.replace('table-', '')
        : false;

      if (dineInObjects?.length > 0) {
        if (number) {
          dineInObject = dineInObjects.find(
            (item) =>
              (item.name === number || item.number === number) &&
              (item.floorLayoutId === floorLayoutId ||
                floors[item.floorLayoutId].name.toLowerCase() ===
                  floorLayoutId.toLowerCase())
          );
          if (dineInObject) {
            this.addTableToOrder(dineInObject);
          } else {
            this.props.setState({
              currentOrder: { ...currentOrder, orderType: `3` },
            });
          }
        } else {
          this.props.setState({
            currentOrder: { ...currentOrder, orderType: `3` },
          });
        }
      }
    }
  };

  handleRedirectionFromMultistore = () => {
    const { currentOrder } = this.props;
    const query = queryString.parse(window.location.search);
    if (query?.lat) {
      query.lat = Number(query.lat);
    }
    if (query?.lng) {
      query.lng = Number(query?.lng);
    }

    let {
      type,
      address,
      lat,
      lng,
      placeId,
      suburbId,
      deliveryCost,
      minOrderValue,
      areaCode,
      area,
    } = query;

    if (type) this.setState({ type });
    if (
      address &&
      lat &&
      lng &&
      placeId &&
      suburbId &&
      deliveryCost &&
      minOrderValue
    ) {
      this.setState({
        address,
        lat,
        lng,
        placeId,
        suburbId,
        deliveryCost,
        minOrderValue,
        ...(areaCode && area
          ? {
              areaCode,
              area,
            }
          : {}),
      });
      this.props.setState({
        currentOrder: {
          ...currentOrder,
          areaCode,
          area,
        },
      });
      this.openAppSectionForType(query);
    }
  };

  openAppSectionForType = ({
    type,
    address,
    lat,
    lng,
    placeId,
    suburbId,
    deliveryCost,
    minOrderValue,
    areaCode,
  }) => {
    const props = this.props;
    const { storeConfig, currentOrder } = props;

    switch (type) {
      case 'dine-in':
      case 'pickup':
        let loadedOrder = loadCurrentOrderMethod(storeConfig, currentOrder);
        loadedOrder.orderType = type === 'dine-in' ? '3' : '1';
        let { currentOd, rowItems } = engineGetOrderCalculations(
          loadedOrder,
          props
        );
        this.props.setState({ currentOrder: currentOd });
        this.setState({ type: ``, rowItems });
        break;
      case 'delivery': {
        let loadedOrder = loadCurrentOrderMethod(storeConfig, currentOrder);
        loadedOrder.orderType = '2';
        loadedOrder.address = address || '';
        loadedOrder.addressLocation = lat && lng ? { lat, lng } : {};
        loadedOrder.placeId = placeId || '';
        loadedOrder.suburbId = suburbId || '';
        loadedOrder.deliveryCost = deliveryCost || '0';
        loadedOrder.minOrderValue = minOrderValue || '0';
        loadedOrder.areaCode = areaCode || '';
        let { currentOd, rowItems } = engineGetOrderCalculations(
          loadedOrder,
          props
        );
        this.props.setState({ currentOrder: currentOd, type: '' });
        this.setState({ rowItems });
        break;
      }
      default:
        break;
    }
  };

  componentWillReceiveProps(props) {
    const { orderSetup, currentOrder, menuItems, allSpecials, halfHalf } =
      props.home;

    if (currentOrder && currentOrder._id && currentOrder.orderStatus !== '-1') {
      this.redirectAndCleanupOrder(props);
    }

    if (currentOrder && menuItems && allSpecials && halfHalf && orderSetup) {
      this.urlChange(props.location.pathname, true);
    }

    if (
      orderSetup &&
      Object.keys(orderSetup).length &&
      !this.state.orderSetup
    ) {
      this.setState({ orderSetup }, () => {
        this.checkForDineIn();
      });
    }

    if (
      orderSetup &&
      !orderSetup.isDeliveryOn &&
      orderSetup.isPickupOn &&
      currentOrder.orderType !== '1' &&
      currentOrder.orderType !== '3'
    ) {
      let loadedOrder = loadCurrentOrderMethod(props.storeConfig, currentOrder);
      loadedOrder.orderType = '1';
      this.props.setState({ currentOrder: loadedOrder });
    } else if (
      orderSetup &&
      !orderSetup.isPickupOn &&
      orderSetup.isDeliveryOn &&
      currentOrder.orderType !== '2' &&
      currentOrder.orderType !== '3'
    ) {
      let loadedOrder = loadCurrentOrderMethod(props.storeConfig, currentOrder);
      loadedOrder.orderType = '2';
      this.props.setState({ currentOrder: loadedOrder });
    }
    if (
      currentOrder?.orderType === '3' &&
      !currentOrder?.tableNumber &&
      currentOrder?.stage < 4 &&
      props.mobileCart
    ) {
      this.setState({ showConfirmTable: true });
    }
  }

  redirectAndCleanupOrder = ({
    home: {
      currentOrder: { _id, orderType },
    },
  }) => {
    if (window.localStorage) {
      const cachedOrder = localStorage.get('currentOrder');
      if (cachedOrder) {
        localStorage.set('currentOrder', {
          address: '',
          addressLocation: {},
          orderStatus: '0',
          orderFrom: '1',
          orderType: '1',
          specials: [],
          menuItems: [],
          stage: 0,
          totalCost: 0,
          payableAmount: 0,
          isAllowToConfirm: false,
        });
      }
    }
    firebaseAnalyticsNO.logEvent(eventNames.PAID_FOR_ORDER);
  };

  addReservationhandler = (obj) => {
    const {
      home: { userDetails },
    } = this.props;
    if (userDetails && userDetails._id) {
      if (isNaN(obj.reservationDate) === true) {
        let reservationInterimDate = new Date(obj.reservationDate);
        obj.reservationDateTimestamp = reservationInterimDate.getTime();
      }
      this.props.addReservationhandler(obj, userDetails);
    }
  };

  // ~updaters~

  updateCurrentUser = (user, details, stage) => {
    const props = this.props;
    const { storeConfig, currentOrder, bookingOpen } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    let newUser = {
      date: moment().tz(storeConfig.timeZone).format(),
      dateTimestamp: getCurrentTimestamp(),
      deviceToken: '',
      email: details.userEmail ? details.userEmail : '',
      firstName: details.firstName,
      isActive: true,
      lastName: details.lastName,
      mobileNumber: getFormattedMobileNumber(details.mobileNumber),
      password: '',
      streetAddress: currentOrder.address ? currentOrder.address : '',
      addressLocation: currentOrder.addressLocation
        ? currentOrder.addressLocation
        : '',
      suburbId: currentOrder.suburbId ? currentOrder.suburbId : '',
      type: '3',
      userRole: '3',
      userId: user.uid,
      ratings: 0,
      totalRatings: 0,
      averageRating: 0,
      totalOrders: 0,
      totalRevenue: 0,
      totalDeliveryOrders: 0,
      totalDeliveryOrdersNow: 0,
      totalPickupOrders: 0,
      deliveryRevenue: 0,
      pickupRevenue: 0,
      totalDeliveryTime: 0,
      averageDeliveryTime: 0,
      storeId: storeConfig.storeId,
      restaurantId: storeConfig.restaurantId,
    };

    if (stage === 3 && (this.state.reservation || bookingOpen)) {
      orderObj.stage = 0;
    } else {
      if (this.state.reservation) {
        orderObj.stage = 0;
      } else if (this.state.initiateDesktopLoyaltyFlow || this.state.loyalty) {
        orderObj.stage = 0;
      } else {
        orderObj.stage = stage;
      }
    }
    let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
    this.props.setState({ currentOrder: currentOd });
    this.setState({ userDetails: newUser, rowItems }, () => {
      this.props.getCurrentUseDetailsHandler(
        user,
        newUser,
        storeConfig.storeId,
        storeConfig.restaurantId,
        true
      );
    });
  };

  updateOrderType = (type, flag) => {
    const props = this.props;
    const { currentOrder } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    if (type === '1') {
      orderObj.orderType = type;
      orderObj.address = '';
      orderObj.addressLocation = '';
      orderObj.placeId = '';
      orderObj.suburbId = '';
      orderObj.minOrderValue = '';
      orderObj.areaCode = '';
      orderObj.area = '';
      orderObj.deliveryCost = 0;
      orderObj.deliveryDate = undefined;
      orderObj.deliveryData = {};
    } else {
      orderObj.orderType = type;
      orderObj.deliveryDate = undefined;
    }

    if (orderObj?.menuItems && orderObj?.menuItems.length > 0) {
      orderObj?.menuItems?.map((menuItem) => {
        if (
          props?.menuItemSizes?.length ||
          props?.menuItemSubModifiers?.length
        ) {
          const newMenuItemSizes = props?.menuItemSizes.filter(
            (f) =>
              f.orderType === orderObj.orderType &&
              f.menuItemId === menuItem._id
          );
          const newMenuItemSubModifiers = props?.menuItemSubModifiers.filter(
            (f) =>
              f.orderType === orderObj.orderType &&
              f.menuItemId === menuItem._id
          );
          return getMenuItemForInstore(
            menuItem,
            newMenuItemSizes,
            newMenuItemSubModifiers,
            false
          );
        } else {
          return menuItem;
        }
      });
    }

    let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
    this.props.setState({
      currentOrder: {
        ...currentOd,
        notes: orderObj.notes,
      },
    });
    this.setState({
      rowItems,
      type: flag ? this.state.type : undefined,
      address: flag ? this.state.address : undefined,
      lat: flag ? this.state.lat : undefined,
      lng: flag ? this.state.lng : undefined,
      placeId: flag ? this.state.placeId : undefined,
      suburbId: flag ? this.state.suburbId : undefined,
      deliveryCost: flag ? this.state.deliveryCost : undefined,
      minOrderValue: flag ? this.state.minOrderValue : undefined,
      areaCode: flag ? this.state.areaCode : undefined,
    });
  };

  updateOrderStage = (stage) => {
    const props = this.props;
    const { currentOrder, home } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    if (
      stage === 1 &&
      (home?.currentUser?.phoneNumber || home?.userDetails?.mobileNumber)
    ) {
      this.props.setState({ currentOrder: { ...currentOrder, stage: 3 } });
    } else if (stage === 3) {
      if (orderObj.stage === 4.1) {
        this.props.setState({ currentOrder: { ...currentOrder, stage: 4 } });
      }
    } else {
      orderObj.stage = stage;
      if (stage === 4) {
        orderObj.paymentType = '0';
      }
      if (stage === 4.1) orderObj.paymentType = '2';
      let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
      this.setState({ rowItems });
      this.props.setState({ currentOrder: currentOd });
    }
  };

  updateOrderStageBack = () => {
    const props = this.props;
    const { currentOrder } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    if (currentOrder.stage === 3) {
      this.props.setState({ currentOrder: { ...currentOrder, stage: 0 } });
    } else if (currentOrder.stage === 2) {
      this.props.setState({ currentOrder: { ...currentOrder, stage: 1.1 } });
    } else if (currentOrder.stage === 1.1) {
      this.props.setState({ currentOrder: { ...currentOrder, stage: 1 } });
    } else if (currentOrder.stage === 4.1) {
      this.props.setState({
        currentOrder: { ...currentOrder, stage: 4, paymentType: `0` },
      });
    } else {
      if (currentOrder.stage === 1 || currentOrder.stage === 4)
        orderObj.stage = orderObj.stage - 1;
      if (
        (this.state.initiateDesktopLoyaltyFlow || this.state.loyalty) &&
        currentOrder.stage === 1
      ) {
        this.props.setLayoutFlow(false);
      }
      let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
      this.setState({ rowItems });
      this.props.setState({ currentOrder: currentOd });
    }
  };

  updateOrderDeliveryAddress = (addressObj, suburb, areaCode, area) => {
    const props = this.props;
    const calculations = engineUpdateOrderDeliveryAddress(
      addressObj,
      suburb,
      areaCode,
      area,
      props
    );

    if (!calculations) return;
    const { currentOd, rowItems } = calculations;
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  updateDeliveryPickupTime = (
    deliveryDate,
    shiftId,
    isCartConfirm,
    stage,
    isFutureDeliveryDate
  ) => {
    const props = this.props;
    const calculations = engineUpdateDeliveryPickupTime(
      deliveryDate,
      shiftId,
      isCartConfirm,
      stage,
      isFutureDeliveryDate,
      props
    );

    if (!calculations) return;
    const { currentOd, rowItems } = calculations;
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  updateVoucher = (voucher) => {
    if (!voucher?._id) return;
    const props = this.props;
    const { currentOrder } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    orderObj.voucherId = voucher._id;
    orderObj.selectedVoucher = voucher;
    let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
    if (!currentOd.isAllowToConfirm) {
      setTimeout(() => {
        this.updateOrderStageBack();
      }, 0);
    }
  };

  saveUnit = (unit) => {
    if (!unit) return;
    const props = this.props;
    const { currentOrder } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    orderObj.unit = unit;
    let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  updatePaymenyType = (
    cardDescription,
    cardNumber,
    cardType,
    isSameCard,
    isCardDetailsValid,
    token,
    cardCountry
  ) => {
    const props = this.props;
    const { currentOd, rowItems } = engineUpdatePaymenyType(
      cardDescription,
      cardNumber,
      cardType,
      isSameCard,
      isCardDetailsValid,
      token,
      cardCountry,
      props
    );

    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  updatePaymentTypeForNewCard = (isCardDetailsValid, card) => {
    const props = this.props;

    let { currentOd, rowItems } = engineUpdatePaymentTypeForNewCard(
      isCardDetailsValid,
      card,
      props
    );
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  updatePaymentTypeForCash = () => {
    const props = this.props;
    const { currentOrder } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    orderObj.paymentType = '1';
    orderObj.cardNumber = '';
    orderObj.cardType = '';
    orderObj.isInternationCard = false;
    let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  updatePaymentTypeForWallet = () => {
    const props = this.props;
    const { currentOrder } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    orderObj.paymentType = '2';
    orderObj.cardNumber = '';
    orderObj.cardType = '';
    orderObj.isInternationCard = false;
    let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  updatePaymentTypeForCard = () => {
    const props = this.props;
    const { currentOrder } = props;
    let orderObj = JSON.parse(JSON.stringify(currentOrder));
    if (orderObj.paymentType === '2') orderObj.paymentType = '2';
    else orderObj.paymentType = '2';
    orderObj.stage = 4.1;
    let { currentOd, rowItems } = engineGetOrderCalculations(orderObj, props);
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  // ~combiners~

  addToOrder = (item) => {
    const props = this.props;
    const calculations = engineAddToOrder(item, props);

    if (!calculations) return;

    const { currentOd, rowItems } = calculations;
    this.props.setState({ currentOrder: currentOd });
    this.setState({
      rowItems,
      rightSideViewVisibilityIndex: 0,
    });
    setTimeout(() => {
      this.setState({ itemInProgress: null });
    }, 0);
  };

  addTableToOrder = (table) => {
    const props = this.props;

    const { currentOd, rowItems } = engineAddTableToOrder(table, props);

    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  addItemsToOrder = (items) => {
    const props = this.props;

    const { currentOd, rowItems } = engineAddItemsToOrder(items, props);

    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  addHalfItemsToOrder = (itemFH, itemSH, halfHalfAdditionalCharges) => {
    const props = this.props;
    const { currentOd, rowItems } = engineAddHalfItemsToOrder(
      itemFH,
      itemSH,
      halfHalfAdditionalCharges,
      props
    );
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  addToSpecial = (item) => {
    if (!this.state.specialItem?._id) return;

    const { selectedSpecials, specialItem } = this.state;
    const { boxIndex } = this.props;
    const newList = engineAddToSpecial(
      item,
      { selectedSpecials, specialItem },
      { boxIndex }
    );

    this.setState((prevState) => ({
      rightSideViewVisibilityIndex: 3,
      itemExist: -1,
      selectedSpecials: newList,
      itemInProgress: { ...prevState.itemInProgress, _id: 'specialTest' },
      orderItem: { ...prevState.orderItem, _id: 'specialTest' },
    }));
  };

  addToHalfHalf = (item) => {
    const { selectedHalfItems, whichHalf } = this.state;
    const { halfHalfSetup } = this.props;
    const itemsPresent = engineAddToHalfHalf(
      item,
      { selectedHalfItems, whichHalf },
      { halfHalfSetup }
    );

    this.setState({
      rightSideViewVisibilityIndex: 4,
      whichHalf: this.state.whichHalf === 1 ? 2 : 1,
      selectedHalfItems: itemsPresent,
    });
    setTimeout(() => {
      this.setState({
        itemInProgress: null,
      });
    }, 0);
  };

  addSpecialToOrder = (specialItem) => {
    if (
      specialItem &&
      specialItem.selectedCategories &&
      this.state.selectedSpecials
    ) {
      this.props.filterView({
        isSpecialFilterApplied: false,
        spMenuItems: [],
        spMenuSizes: [],
        spSubModifiers: [],
        spMenuCategories: [],
        boxIndex: -1,
      });

      this.setState({ rightSideViewVisibilityIndex: 0, specialItem: {} });
      let menuUnderline = document.getElementsByClassName(
        'tabsSlider--menuUnderline'
      );
      if (menuUnderline[0]) {
        menuUnderline[0].style.width = '53px';
      }

      let itemsToBeAdded = engineDoASelfMerge(this.state.selectedSpecials);
      this.addItemsToOrder(itemsToBeAdded.filter(({ isHalf }) => !isHalf));

      setTimeout(() => {
        const halfItems = this.state.selectedSpecials.filter(
          ({ isHalf }) => isHalf
        );

        if (halfItems) {
          const grouped = Object.values(
            halfItems.reduce(
              (acc, item) => ({
                ...acc,
                [item.boxIndex]: [
                  ...(acc[item.boxIndex] || []),
                  {
                    ...item,
                    halfIndex: item.halfIndex + item.boxIndex,
                  },
                ],
              }),
              {}
            )
          );

          for (const [FH, SH] of grouped) {
            if (FH && SH) {
              this.addHalfItemsToOrder(FH, SH, 0);
            } else if (!SH) {
              this.addItemsToOrder([{ ...FH, quantity: 1, isHalf: false }]);
            } else if (!FH && SH) {
              this.addItemsToOrder([{ ...SH, quantity: 1, isHalf: false }]);
            }
          }
        }
      }, 300);
    }
  };

  incrementItemQuantity = (sizeObj, itemObj) => {
    const props = this.props;
    const calculations = engineIncrementItemQuantity(sizeObj, itemObj, props);
    if (!calculations) return;
    const { currentOd, rowItems } = calculations;

    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  incrementExtraQuantity = (extraObj, itemObj, whichHalf) => {
    const props = this.props;
    const calculations = engineIncrementExtraQuantity(
      extraObj,
      itemObj,
      whichHalf,
      props
    );
    if (!calculations) return;
    const { currentOd, rowItems } = calculations;

    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  decrementItemQuantity = (sizeObj, itemObj, whichHalf) => {
    const props = this.props;
    const calculations = engineDecrementItemQuantity(sizeObj, itemObj, props);
    if (!calculations) return;
    const { currentOd, rowItems } = calculations;

    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  decrementExtraQuantity = (extraObj, itemObj, whichHalf) => {
    const props = this.props;
    const calculations = engineDecrementExtraQuantity(
      extraObj,
      itemObj,
      whichHalf,
      props
    );
    if (!calculations) return;
    const { currentOd, rowItems } = calculations;

    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  // ~half/half~

  clearItemsNotAvailableForVariants = (itemVariants) => {
    this.setState({ selectedHalfItems: [], itemVariants });
  };

  addHalfHalfToOrder = () => {
    const { selectedHalfItems, itemVariants } = this.state;
    const { currentOrder, halfHalfSetup } = this.props;
    if (!(selectedHalfItems && selectedHalfItems.length >= 2)) return;

    const { firstItem, secondItem, newCharges } = engineAddHalfHalfToOrder(
      { selectedHalfItems, itemVariants },
      { currentOrder, halfHalfSetup }
    );

    if (this.props.isSpecialFilterApplied) {
      this.setState({
        rightSideViewVisibilityIndex: 3,
        halfItem: {},
        itemVariants: [],
      });
      this.addToSpecial([firstItem, secondItem]);
    } else {
      this.setState(
        {
          rightSideViewVisibilityIndex: 0,
          halfItem: {},
          itemVariants: [],
        },
        () => {
          let menuUnderline = document.getElementsByClassName(
            'tabsSlider--menuUnderline'
          );
          if (menuUnderline[0]) {
            menuUnderline[0].style.width = '53px';
          }

          // add global menu item quantity field
          firstItem.quantity = 0.5;
          secondItem.quantity = 0.5;

          this.addHalfItemsToOrder(firstItem, secondItem, newCharges);
          this.props.history.replace('/category/popular');
        }
      );
    }
  };

  // ~mergers~

  removeOutOfScheduleItems = () => {
    const props = this.props;
    const { currentOd, rowItems } = engineRemoveOutOfScheduleItems(props);
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  removeSoldOutItems = () => {
    const props = this.props;
    const { currentOd, rowItems } = engineRemoveSoldOutItems(props);
    this.setState({ rowItems });
    this.props.setState({ currentOrder: currentOd });
  };

  showSpecialsHandler = (arrObj) => {
    this.setState((prevState) => {
      return {
        arrKey: arrObj._id,
        rightSideViewVisibilityIndex: 3,
        toggleSpecials:
          prevState.arrKey === arrObj._id
            ? this.state.toggleSpecials
            : !this.state.toggleSpecials,
        specialItem: arrObj,
        selectedSpecials: [],
      };
    });
  };

  showSpecialItem = (arrObj) => {
    const { spMenuSizes, spSubModifiers } = this.props;
    const obj = engineShowSpecialItem(arrObj, { spMenuSizes, spSubModifiers });
    if (!obj) return;

    this.setState((prevState) => {
      return {
        arrKey: arrObj.name,
        rightSideViewVisibilityIndex: 2,
        toggleSpeacialItem:
          prevState.arrKey === arrObj.name
            ? this.state.toggleSpeacialItem
            : !this.state.toggleSpeacialItem,
        orderItem: obj,
        itemInProgress: obj,
      };
    });
  };

  showHalfItem = (arrObj) => {
    const { itemVariants, hhActiveMenuSizes } = this.state;
    const obj = engineShowHalfItem(arrObj, { itemVariants, hhActiveMenuSizes });
    this.setState((prevState) => {
      return {
        arrKey: arrObj.name,
        rightSideViewVisibilityIndex: 5,
        toggleSpeacialItem:
          prevState.arrKey === arrObj.name
            ? this.state.toggleSpeacialItem
            : !this.state.toggleSpeacialItem,
        orderItem: obj,
        itemInProgress: obj,
      };
    });
  };

  showHalfViewHandler = (arrObj) => {
    const isMobile =
      window.innerWidth < 992 ||
      (window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250);
    this.setState(
      {
        rightSideViewVisibilityIndex: 4,
      },
      () => {
        this.setState((prevState) => ({
          halfAnimation:
            prevState.arrKey === arrObj.name
              ? this.state.halfAnimation
              : !this.state.halfAnimation,
          arrKey: arrObj.name,
          selectedHalfItems: [],
          halfItem: arrObj,
          whichHalf: isMobile ? null : 1,
        }));
      }
    );
  };

  halfFilter = (whichHalf, itemVariants, hhActiveMenuSizes) => {
    this.setState({
      whichHalf,
      itemVariants,
      hhActiveMenuSizes,
    });
    if (
      window.innerWidth < 992 ||
      (window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250)
    ) {
      this.setState({ rightSideViewVisibilityIndex: 0 });
    }
  };

  clearOrChangeSize = (hhActiveMenuSizes, itemVariants) => {
    const selectedHalfItems = this.state.selectedHalfItems;
    const { home } = this.props;

    const obj = engineClearOrChangeSize(
      hhActiveMenuSizes,
      itemVariants,
      selectedHalfItems,
      { home }
    );

    this.setState((prevState) => ({ ...prevState, ...obj }));
  };

  showMenuItemHandler = (arrObj) => {
    if (!arrObj) return;
    const { soldOutMenuItems } = this.props;

    const obj = engineShowMenuItemHandler(arrObj, { soldOutMenuItems });

    this.setState((prevState) => ({
      arrKey: arrObj._id,
      rightSideViewVisibilityIndex: 1,
      toggleAnimation:
        prevState.arrKey === arrObj._id
          ? this.state.toggleAnimation
          : !this.state.toggleAnimation,
      orderItem: obj,
      itemInProgress: obj,
    }));
  };

  hideOrder = () => {
    const { filterView } = this.props;
    const { halfItem, specialItem } = this.state;

    const isSpecialOpen = Object.keys(specialItem).length > 0;
    const isHalfOpen = Object.keys(halfItem).length > 0;

    if (isSpecialOpen && isHalfOpen) {
      this.setState({
        halfItem: {},
        rightSideViewVisibilityIndex: isSpecialOpen ? 3 : 0,
        itemInProgress: null,
      });
    } else if (isSpecialOpen) {
      this.setState({
        specialItem: {},
        rightSideViewVisibilityIndex: 0,
        itemInProgress: null,
      });

      filterView({
        isSpecialFilterApplied: false,
        spMenuItems: [],
        spMenuSizes: [],
        spSubModifiers: [],
        spMenuCategories: [],
        boxIndex: -1,
        itemExist: -1,
      });
    } else if (isHalfOpen) {
      this.setState({
        halfItem: {},
        rightSideViewVisibilityIndex: 0,
        itemInProgress: null,
      });
    } else {
      this.setState({ rightSideViewVisibilityIndex: 0, itemInProgress: null });
    }
  };

  hideSpecialItem = () => {
    this.setState({ rightSideViewVisibilityIndex: 3, itemInProgress: null });
  };

  mobileGoback = () => {
    this.setState({ rightSideViewVisibilityIndex: 4 });
  };

  hideHalfItem = () => {
    this.setState({ rightSideViewVisibilityIndex: 4, itemInProgress: null });
  };

  filterView = (
    spMenuItems,
    spMenuSizes,
    spSubModifiers,
    spMenuCategories,
    boxIndex,
    itemExist
  ) => {
    this.props.filterView({
      isSpecialFilterApplied: true,
      boxIndex,
      itemExist,
      spMenuItems,
      spMenuSizes,
      spSubModifiers,
      spMenuCategories,
    });
    if (
      window.innerWidth < 992 ||
      (window.navigator.userAgent.match(/iPad/i) && window.innerHeight > 1250)
    ) {
      this.setState({ rightSideViewVisibilityIndex: 0 });
    }
  };

  signOut = () => {
    _auth.signOut().then(() => {
      this.setState({ currentUser: {}, userDetails: {} }, () => {
        this.props.takeSignOutAction();
      });
    });
  };

  goHome = () => {
    const props = this.props;
    const { currentOrder } = props;
    const { orderStatus, id, orderType } = currentOrder;
    if (
      orderStatus === '1' ||
      orderStatus === '4' ||
      orderStatus === '11' ||
      this.qrRedirect === 'true' ||
      this.qrTracking === 'close'
    ) {
      let ctOrder = {
        paymentType: '0',
        orderStatus: '0',
        orderFrom: '1',
        orderType: orderType === '3' ? '3' : '1',
        specials: [],
        menuItems: [],
        stage: 0,
        totalCost: 0,
        payableAmount: 0,
        date: '',
        deliveryCode: '',
        deliveryCost: '0',
        deliveryDate: '',
        id,
        index: 68,
        shiftId: '',
        voucherId: '',
        userId: '',
        driverId: '',
        suburbId: '',
        txnId: '',
        transactionReference: '',
        cardNumber: '',
        cardType: '',
      };

      let { currentOd, rowItems } = engineGetOrderCalculations(ctOrder, props);

      this.setState({ driver: {}, rowItems }, () => {
        if (this.props.mobileCart) this.props.toggleMobileCart();
        currentOd.floorLayoutId = currentOrder.floorLayoutId;
        currentOd.tableNumber = currentOrder.tableNumber;
        if (
          orderType === '3' ||
          this.qrRedirect === 'true' ||
          this.qrTracking === 'close'
        ) {
          this.props.history.replace({
            query: null,
          });
        }
      });
      this.props.setState({ currentOrder: currentOd });
    }
  };

  getDiscountedAmount = (
    selectedVoucher,
    currentOrder,
    rowItems,
    specialDiscount
  ) => {
    const { storeConfig, home, publicHolidays } = this.props;
    const currentOd = currentOrder || home.currentOrder;
    const rItems = rowItems || getItemsInCart(currentOd);
    const resObj = getVoucherDiscountedAmount(
      selectedVoucher,
      currentOd,
      rItems,
      specialDiscount,
      home.allSpecials,
      home.orderSetup,
      publicHolidays,
      storeConfig
    );
    return resObj;
  };

  render() {
    const { isSpecialFilterApplied, currentOrder } = this.props;
    const { halfItem, showSelectTable, showConfirmTable, floors } = this.state;
    const halfView = Object.keys(halfItem).length > 0;

    return (
      <React.Fragment>
        <Layout
          showHalfItem={halfView}
          halfItem={this.state.halfItem}
          signOut={this.signOut}
          goHome={this.goHome}
          hOrder={this.mobileGoback}
          reservation={this.state.reservation}
          closeLoyalty={this.closeLoyalty}
          loyalty={this.state.loyalty}
          updateOrderStage={this.updateOrderStage}
          addReservationhandler={this.addReservationhandler}
          history={this.props.history}
          // review={this.state.review} // ⛔️ Not Needed
          // updateCurrentUser={this.updateCurrentUser} // ⛔️ Not Needed
          // openDelivery={this.state.openDelivery} // ⛔️ Not Needed
        >
          <div
            className={`container-fluid shadowIt ${
              isSpecialFilterApplied ? 'spViewActive' : ''
            }`}
          >
            <div className='row' style={{ overflow: 'auto' }}>
              <div
                className={
                  !!currentOrder &&
                  currentOrder.stage &&
                  currentOrder.stage >= '5'
                    ? 'col-xs-12 customWidth noPad'
                    : currentOrder.stage >= 3
                    ? 'col-md-8 customWidth mapStage'
                    : 'col-md-8 customWidth'
                }
              >
                <div className='map-items' style={{ height: '100%' }}>
                  {currentOrder &&
                  currentOrder.stage &&
                  currentOrder.stage >= 3 &&
                  currentOrder.isAllowToConfirm ? (
                    <ReviewOrder
                      updateOrderDeliveryAddress={
                        this.updateOrderDeliveryAddress
                      }
                      // updateDeliveryPickupTime={this.updateDeliveryPickupTime}
                      saveUnit={this.saveUnit}
                    />
                  ) : (
                    <MenuItems
                      halfView={halfView}
                      halfItem={this.state.halfItem}
                      hhActiveMenuSizes={this.state.hhActiveMenuSizes}
                      showSpecialsHandler={this.showSpecialsHandler}
                      showHalfViewHandler={this.showHalfViewHandler}
                      showMenuItemHandler={this.showMenuItemHandler}
                      showSpecialItem={this.showSpecialItem}
                      showHalfItem={this.showHalfItem}
                      history={this.props.history}
                      location={this.props.location}
                      itemVariants={this.state.itemVariants}
                      selectedHalfItems={this.state.selectedHalfItems}
                      // initiateDesktopLoyaltyFlow={
                      //   this.state.initiateDesktopLoyaltyFlow
                      // } // ⛔️ Not Used
                    />
                  )}
                </div>
              </div>
              {currentOrder && (
                <Order
                  hideSpecialItem={this.hideSpecialItem}
                  filterView={this.filterView}
                  toggleSpecials={this.state.toggleSpecials}
                  specialItem={this.state.specialItem}
                  showSpecialItem={this.showSpecialItem}
                  hideOrder={this.hideOrder}
                  halfAnimation={this.state.halfAnimation}
                  halfItem={this.state.halfItem}
                  toggleSpeacialItem={this.state.toggleSpeacialItem}
                  orderItem={this.state.orderItem}
                  itemInProgress={this.state.itemInProgress}
                  toggleAnimation={this.state.toggleAnimation}
                  halfFilter={this.halfFilter}
                  updateOrderType={this.updateOrderType}
                  addToOrder={this.addToOrder}
                  incrementItemQuantity={this.incrementItemQuantity}
                  decrementItemQuantity={this.decrementItemQuantity}
                  incrementExtraQuantity={this.incrementExtraQuantity}
                  decrementExtraQuantity={this.decrementExtraQuantity}
                  updateOrderDeliveryAddress={this.updateOrderDeliveryAddress}
                  updateDeliveryPickupTime={this.updateDeliveryPickupTime}
                  updateOrderStage={this.updateOrderStage}
                  updateOrderStageBack={this.updateOrderStageBack}
                  updateCurrentUser={this.updateCurrentUser}
                  updateVoucher={this.updateVoucher}
                  updatePaymenyType={this.updatePaymenyType}
                  updatePaymentTypeForCash={this.updatePaymentTypeForCash}
                  updatePaymentTypeForWallet={this.updatePaymentTypeForWallet}
                  updatePaymentTypeForCard={this.updatePaymentTypeForCard}
                  updatePaymentTypeForNewCard={this.updatePaymentTypeForNewCard}
                  addToSpecial={this.addToSpecial}
                  rightSideViewVisibilityIndex={
                    this.state.rightSideViewVisibilityIndex
                  }
                  selectedSpecials={this.state.selectedSpecials}
                  addSpecialToOrder={this.addSpecialToOrder}
                  selectedHalfItems={this.state.selectedHalfItems}
                  addToHalfHalf={this.addToHalfHalf}
                  hideHalfItem={this.hideHalfItem}
                  addHalfHalfToOrder={this.addHalfHalfToOrder}
                  clearItemsNotAvailableForVariants={
                    this.clearItemsNotAvailableForVariants
                  }
                  whichHalf={this.state.whichHalf}
                  // menuItems={this.props.home.menuItems} // ⛔️ Not Used
                  clearOrChangeSize={this.clearOrChangeSize}
                  history={this.props.history}
                  saveUnit={this.saveUnit}
                  itemExist={this.state.itemExist}
                  initiateDesktopLoyaltyFlow={
                    this.state.initiateDesktopLoyaltyFlow
                  }
                  loyalty={this.state.loyalty}
                  addReservationhandler={this.addReservationhandler}
                  reservation={this.state.reservation}
                  // userDetails={this.props.home.userDetails} // ⛔️ Not Used
                  // currentUser={this.props.home.currentUser} // ⛔️ Not Used
                  removeSoldOutItems={this.removeSoldOutItems}
                  removeOutOfScheduleItems={this.removeOutOfScheduleItems}
                  openDelivery={this.state.openDelivery}
                  getDiscountedAmount={this.getDiscountedAmount}
                  inLayoutFlow={this.state.inLayoutFlow}
                  dineInObjects={this.state.dineInObjects}
                  floors={this.state.floors}
                  addTableToOrder={this.addTableToOrder}
                />
              )}
              {this.props.currentOrder?.orderType === '3' &&
                !this.props.currentOrder?.tableNumber &&
                this.props.mobileCart &&
                this.props.currentOrder?.stage < 4 && (
                  <>
                    {showConfirmTable && (
                      <ConfirmTable
                        confirmTable={this.confirmTable}
                        hideModal={() => {
                          this.setState({ showConfirmTable: false });
                        }}
                      />
                    )}
                    {showSelectTable && (
                      <SelectTable
                        floors={floors}
                        hideModal={() => {
                          this.setState({
                            showSelectTable: false,
                            showConfirmTable: true,
                          });
                        }}
                        addTableToOrder={this.addTableToOrder}
                      />
                    )}
                  </>
                )}
            </div>
          </div>
        </Layout>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const {
    homeReducer: {
      soldOutMenuItems,
      currentOrder,
      bookingOpen,
      specialFilter: {
        isSpecialFilterApplied,
        spMenuItems,
        spMenuSizes,
        spSubModifiers,
        spMenuCategories,
        boxIndex,
      },
      menuItemSchedules,
      ui: { mobileCart },
    },
    layoutReducer: {
      storeConfig,
      halfHalfSetup,
      offers,
      autoVouchers,
      publicHolidays,
    },
  } = state;

  return {
    isSpecialFilterApplied,
    spMenuItems,
    spMenuSizes,
    spSubModifiers,
    spMenuCategories,
    soldOutMenuItems,
    boxIndex,
    mobileCart,
    halfHalfSetup,
    currentOrder,
    bookingOpen,
    menuItemSchedules,
    offers,
    autoVouchers,
    publicHolidays,
    home: state.homeReducer,
    menuItemSizes: state.homeReducer.menuItemSizes,
    menuItemSubModifiers: state.homeReducer.menuItemSubModifiers,
    order: state.orderReducer,
    reviewOrder: state.reviewOrderReducer,
    storeConfig,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setState: (st) => dispatch(setState(st)),
    updateCurrentOrderObjHandler: (id, obj) =>
      dispatch(updateCurrentOrderObj(id, obj)),
    takeSignOutAction: () => dispatch(takeSignOutAction()),
    filterView: (filter) => dispatch(filterView(filter)),
    initAction: (storeId, restaurantId) =>
      dispatch(init(storeId, restaurantId)),
    toggleMobileCart: () => dispatch(toggleMobileCart()),
    setLayoutFlow: (value) => dispatch(setLayoutFlow(value)),
    getCurrentUseDetailsHandler: (
      uid,
      newUser,
      storeId,
      restaurantId,
      isLogin
    ) =>
      dispatch(
        getCurrentUseDetails(uid, newUser, storeId, restaurantId, isLogin)
      ),
    addReservationhandler: (reservation, userDetails) =>
      dispatch(addReservation(reservation, userDetails)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
